const worksBestPopup = document.querySelectorAll(".works-best-popup");

const worksBestOpenBtn = document.querySelectorAll(".works-best-open-btn");
const worksBestCloseBtn = document.querySelectorAll(".works-best-close-btn");

worksBestOpenBtn.forEach((el, id) => {
  const mobile = window.innerWidth <= 768;

  if (mobile) {
    el.addEventListener("click", () => {
      console.log("here");
      worksBestPopup[id].classList.toggle("hidden");
    });
  }

  if (!mobile) {
    el.addEventListener("mouseover", () => {
      worksBestPopup[id].classList.remove("hidden");
    });

    el.addEventListener("mouseleave", () => {
      worksBestPopup[id].classList.add("hidden");
    });
  }
});

worksBestCloseBtn.forEach((el, id) => {
  el.addEventListener("click", () => {
    worksBestPopup[id].classList.toggle("hidden");
  });
});
